import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


/**Obtiene la suma del importe pagado */
export function totalPagadoModel(pago: models.PagoRealizadoDesgloseFeriaModel): number {
    return pago.Conceptos.map(x => x.Monto).reduce((a, b) => a + b, 0) + pago.ImporteEfectivoAntesFeria;
}

export type ErrorPago =  "insuficiente" | "feriaMayorEfectivo" ;
/**Convierte y valida un @see PagoRealizadoModel a un @see PagoReealizado */
export function convertirPagoDesglose(pago: models.PagoRealizadoDesgloseFeriaModel, totalAPagar: number): { resultado: models.PagoRealizadoDesgloseFeriaResult, error?: ErrorPago} {
    const totalPagado = totalPagadoModel(pago);

    const feria = Math.max(totalPagado - totalAPagar, 0);
    const falta = Math.max(totalAPagar - totalPagado, 0);
    const importeEff = pago.ImporteEfectivoAntesFeria - feria;

    const trunc = (x: number) => Math.trunc(x * 100) / 100;

    const error =
        trunc(falta) > 0 ? "insuficiente" :
            trunc(importeEff) < 0 ? "feriaMayorEfectivo" :
                undefined;
    return {
        error: error,
        resultado: {
            Conceptos: pago.Conceptos,
            EsCredito: false,
            Falta: falta,
            Feria: feria,
            ImporteEfectivoAntesFeria: importeEff
        }
    };
}
/**Convierte y valida un @see PagoRealizadoModel a un @see PagoReealizado */
export function convertirPago(pago: models.PagoRealizadoModel, totalAPagar: number) : {resultado: models.PagoRealizadoDesgloseFeriaResult | models.PagoRealizadoCredito , error?: ErrorPago } {
    if(pago.EsCredito) {
        return {
            resultado: pago, 
        }
    } else {
        return convertirPagoDesglose(pago, totalAPagar);
    }
}


// WEBPACK FOOTER //
// ./app/logic/operativa/pago.tsx